import { render, staticRenderFns } from "./VProxyWindow.vue?vue&type=template&id=6626aa11&"
import script from "./VProxyWindow.vue?vue&type=script&lang=ts&"
export * from "./VProxyWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports